import React, { useContext, useState } from "react";

//get the context
import QuoteContext from "../../../quote-context";

//calendar
import Moment from 'moment'
import 'react-dates/initialize';
//import { SingleDatePicker } from 'react-dates';
import SingleDatePicker from 'react-dates/lib/components/SingleDatePicker'
Moment.locale('en-gb', {
  week: {
    dow: 1,
  },
});

const Form = ({ siteId }) => {

	//context
	const {navigation, navigationDispatcher, formData, formDispatcher} = useContext(QuoteContext);

	//states
	const[datePickerIsFocused, setDatePickerIsFocused] = useState(false);
	const[showPaxAlert, setShowPaxAlert] = useState(false);

	//error handling
	const fieldHasError = (key) => {
		return !!(navigation.error.fields.find(err => err==key))
	}

	//pax
	const renderPax = (min, max) => {
		let options = [];
		for(let i=min; i<=max; i++){
			options.push(<option key={`pax-option-${i}`} value={i}>{i} guests</option>);
		}
		return options;
	}

	//calendar
	const blocksDay = (day) => {
		return day.isSameOrBefore(Moment(), "day");
	}

	const parseDate = (date) => {
		if( date === null || date === "" ) {
			return null;
		}
		let objDate = Moment();
		const dateParts = date.split('/');
		objDate.set('year', Number(dateParts[2]) );
		objDate.set('month', Number(dateParts[1])-1 );  // April
		objDate.set('date', Number(dateParts[0]) );
		objDate.set('hour', 4 );
		objDate.set('minute', 0);
		objDate.set('second', 0 );
		objDate.set('millisecond', 0);
		return objDate;
	}

	const renderMonthElement = ({ month, onMonthSelect, onYearSelect }) => {

		let returnYears = () => {
			let objDate = Moment();
			let years = []
			for(let i = objDate.year(); i <= objDate.year() + 10; i++) {
				years.push(<option key={i} value={i}>{i}</option>);
			}
			return years;
		}

		return (
			<div style={{marginTop: '-2.8rem', position: 'absolute', left: '16%', width: '200px'}}>
				<div style={{width: '40%', display: 'inline-block'}}>
					<select value={month.month()} onChange={(e) => onMonthSelect(month, e.target.value)} style={{backgroundColor: 'white'}}>
						{Moment.monthsShort().map((label, value) => (
							<option key={value} value={value}>{label}</option>
						))}
					</select>
				</div>
				<div style={{width: '35%', display: 'inline-block'}}>
					<select value={month.year()} onChange={(e) => onYearSelect(month, e.target.value)} style={{backgroundColor: 'white'}}>
						{returnYears()}
					</select>
				</div>
			</div>
		)
	}

	const handlePaxChange = (pax) => {
		if(formData.activities.length > 0||formData.hotel!==false){
			setShowPaxAlert(true);
		}
		formDispatcher({type: "UPDATE_PAX", value: pax})
	}

	return (
		<>
			<div className="full-width-block white">
				<div className="row no-padding">
					{ showPaxAlert ? (
						<div className="error-label border radius fill mg-b" onClick={()=>setShowPaxAlert(false)}>
							<div className="pd align-content split vertical center">
								<p>Your group size changes have been applied to your activities and hotels below</p>
								<span className="icon icon-close small black right"></span>
							</div>
						</div>
					) : null }
				</div>
			</div>

			<div className="full-width-block white">
				<div className="row no-padding">
					<div className="align-content grid">
						<div className="grid-item one-quarter small-half">
							<div className="select-container full-width-mob">
								<h5>Guests:</h5>
								<label>
									<select className={fieldHasError("pax") ? "form-select fill mg-b-tch radius field-error" : "form-select mg-b-tch fill radius"} onChange={e => handlePaxChange(e.target.value)} defaultValue={formData.pax}>
									{renderPax(3, 50)}
									</select>
								</label>
								{fieldHasError("pax") ? <span className="field-error-label pax-error">Please check this field!</span> : null}
							</div>
						</div>
						<div className="grid-item one-quarter small-half">
							<label className="full-width-mob">
								<h5>Date:</h5>
								<div className={fieldHasError("date") ? "quotev3__itinerary-form--item radius field-error" : "quotev3__itinerary-form--item radius"}>
									<SingleDatePicker
										showDefaultInputIcon
										inputIconPosition="after"
										block={false}
										numberOfMonths={1}
										isOutsideRange={blocksDay}
										date={parseDate(formData.date)}
										onDateChange={date => {
											formDispatcher({type: "UPDATE_FIELD", key: "date", value: date.format("DD/MM/YYYY")})
											navigationDispatcher({type: "RESET_ERRORS"})
											navigationDispatcher({type: "SET_PROGRESS", progress: 2})

											navigationDispatcher({
												type: 'TRACK_EVENT',
												action: 'event',
												name: 'select-date',
												category: 'form-select',
												trigger: 'web-js',
												data:  {
													pax: formData.pax,
													date: date.format("DD/MM/YYYY")
												}
											})

										}}
										renderMonthElement={renderMonthElement}
										focused={datePickerIsFocused}
										onFocusChange={({ focused }) =>
											setDatePickerIsFocused(focused)
										}
										hideKeyboardShortcutsPanel={true}
										readOnly
										withFullScreenPortal={window.matchMedia("(max-width: 768px)").matches}
										displayFormat="DD/MM/YYYY"
									/>
								</div>
							</label>
							{fieldHasError("date") ? <span className="field-error-label date-error">Please check this field!</span> : null}
						</div>
					</div>
				</div>
			</div>
			<div className="full-width-block white pd-v">
				<div className="row no-padding">
					<div className="column">
						{ siteId == 1 ? 
							<div className="align-content vertical top">
								<span className="icon icon-important black left"></span>
								<p>Not sure of numbers or dates? No problem - just enter an estimate and you can change it later!</p>
							</div>
						: 	
							<div className="content-block green radius pd border fill">
								<div className="align-content vertical top">
									<span className="icon icon-group large green left"></span>
									<h4 className="no-mg-b green">Finalise guest numbers later</h4>
								</div>
								<p>Estimate your group size to lock in your itinerary and finalise closer to the event.</p>
							</div> 
						}
					</div>
				</div>
			</div>
		</>
	)
}

export default Form;
